import { ResolverTag } from '@ps/web-core-enums';
import { Translation } from '@ps/web-shared-components';
import React from 'react';

import InfoMessage from '@swf/components/InfoMessage/InfoMessage';
import ResolverLink from '@swf/components/ResolverLink/ResolverLink';

import {
  TXTWCL_Gambling_may_lead_to_addiction_ELL,
  TXTWCL_Read_our_guidance_Xa_hrefXXhel_ELL,
  TXTWCL_Responsible_Gambling,
  TXTWCL_Time_since_last_gaming_session_ELL
} from './SaferGamingMessage.messages.json';

interface Props {
  lastSessionEndTime: number;
}

const elapsedMinutes = (endTime: number) =>
  Math.floor((Math.floor(Date.now() / 1000) - endTime) / 60);

const SaferGamingMessage: React.FC<Props> = ({ lastSessionEndTime }) => (
  <InfoMessage type="info" messageTitle={TXTWCL_Responsible_Gambling}>
    <Translation
      tagName="div"
      values={{ 0: elapsedMinutes(lastSessionEndTime) }}
      {...TXTWCL_Time_since_last_gaming_session_ELL}
    />
    <div>
      <Translation {...TXTWCL_Gambling_may_lead_to_addiction_ELL} />{' '}
      <Translation
        values={{
          a: (msg: React.ReactNode) => (
            <ResolverLink resolverTag={ResolverTag.HelpResponsibleGaming}>{msg}</ResolverLink>
          )
        }}
        {...TXTWCL_Read_our_guidance_Xa_hrefXXhel_ELL}
      />
    </div>
  </InfoMessage>
);

export default SaferGamingMessage;
